<template>
  <app-modal
    ref="modal"
    v-bind="$attrs"
    class="modal-container"
    content-class="modal-medium"
    title="エクストラネット接続状態"
  >
    <template v-slot:body="{ cancel }">
      <!-- BODY -->
      <v-card-text class="pa-0">
        <div class="modal-body">
          <v-container>
            <v-row>
              <v-col class="d-flex flex-row ga-2 justify-end">
                <!-- v-if:接続先V番号が自V番の場合「申請中」のステータスは存在しないけど、プロビが走るので一時に「申請中」となっている。該当場合、取下げボタンが表示しないようにするため -->
                <v-btn
                  v-if="
                    !(
                      approvalRequestType === 'DROP' &&
                      connectInfo.dstVNumber ===
                        $store.state.user.contractSummary.vnumber
                    )
                  "
                  v-permission.config
                  color="primary"
                  @click="statusChange()"
                >
                  {{ $filter.enumTo(approvalRequestType, "approvalRequest") }}
                </v-btn>
                <v-btn
                  v-if="approvalRequestType === 'APPROVE'"
                  v-permission.config
                  color="primary"
                  @click="rejection"
                >
                  却下
                </v-btn>
              </v-col>
            </v-row>
            <connection-info-table :connectionInfo="connectInfo" />
          </v-container>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <!-- FOOTER -->
      <v-card-actions>
        <v-list-item class="w-100 pa-1">
          <template v-slot:append>
            <v-btn @click="cancel" variant="outlined" color="primary"
              >戻る</v-btn
            >
          </template>
        </v-list-item>
      </v-card-actions>
    </template>
  </app-modal>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { defineComponent } from "vue";
import { VueFinalModal } from "vue-final-modal";
import type { ExtranetInfo, PutExtranetInfo } from "@/apis/ExtranetApi";
import ConnectionInfoTable from "@/components/extranet/ConnectionInfoTable.vue";
import ExtranetDisconnectConfirm from "@/modals/extranet/ExtranetDisconnectConfirm.vue";
import ExtranetConnectApproval from "@/modals/extranet/ExtranetConnectApproval.vue";

export default defineComponent({
  name: "ExtranetConnectReference",
  components: { ConnectionInfoTable },
  props: {
    connectInfo: {
      type: Object as PropType<ExtranetInfo>,
      required: true,
    },
    extranetKeyId: {
      type: String as PropType<string>,
      required: true,
    },
  },
  computed: {
    /** 承認ステータスの変更要求 */
    approvalRequestType(): PutExtranetInfo["approvalRequest"] {
      // 承認ステータスが完了の場合は、変更要求が切断となる
      if (this.connectInfo.approvalState === "COMPLETE") {
        return "DISCONNECT";
      } else {
        // 接続元V番号とユーザーのV番号が一致する状態は申請側、一致しない場合は承認側となる
        if (
          this.connectInfo.srcVNumber ===
          this.$store.state.user.contractSummary.vnumber
        ) {
          // 承認ステータスが申請中の場合は、変更要求が取り下げとなる
          return "DROP";
        } else {
          // 承認ステータスが未承認(承認側でステータスが申請中)の場合は、変更要求が承認もしくは却下となる
          return "APPROVE";
        }
      }
    },
  },
  methods: {
    /**
     * エクストラネットの承認・取り下げ・切断を行う
     */
    async statusChange() {
      if (this.approvalRequestType === "APPROVE") {
        await this.$modal.show(ExtranetConnectApproval, {
          confirmData: this.connectInfo,
          extranetKeyId: this.extranetKeyId,
        });
      } else {
        // 取り下げ・切断
        await this.$modal.show(ExtranetDisconnectConfirm, {
          confirmData: this.connectInfo,
        });
        // APIに送信するデータの設定
        const data: PutExtranetInfo = {
          pinCode: null,
          approvalRequest: this.approvalRequestType,
          note: null,
          extranetKeyId: this.extranetKeyId,
        };
        // APIによるエクストラネット取り下げ処理
        await this.$api.extranetApi.putExtranet(
          this.connectInfo.extranetSeq,
          data
        );
      }
      (this.$refs.modal as typeof VueFinalModal & { ok: () => void }).ok();
    },

    /** エクストラネット接続申請を却下する */
    async rejection() {
      await this.$confirm(
        `エクストラネット接続申請を却下します。よろしいですか？`
      );

      // APIに送信するデータの設定
      const data: PutExtranetInfo = {
        pinCode: null,
        approvalRequest: "REJECTED",
        note: null,
        extranetKeyId: this.extranetKeyId,
      };

      // APIによるエクストラネット却下処理
      await this.$api.extranetApi.putExtranet(
        this.connectInfo.extranetSeq,
        data
      );
      (this.$refs.modal as typeof VueFinalModal & { ok: () => void }).ok();
    },
  },
});
</script>
